<template>
  <div
    data-qa="stars_rate"
    class="rating-badge d-inline-flex align-center gc-1 py-1 px-2 rounded bg-gray-40"
  >
    <span
      class="ui-icon-rating-star-filled ui-icon-fz-medium rating--text flex-shrink-0"
    />
    <span class="text-subtitle-1 text--text text-no-wrap">
      {{ formatRatingScore(solidity) }}
    </span>
  </div>
</template>

<script lang="ts" setup>
/**
 * Badge рейтинга: звезда и оценка с одной цифрой после точки.
 */
import formatRatingScore from 'common/filters/formatRatingScore'

defineProps<{
  solidity: number
}>()
</script>
